module.exports = __webpack_public_path__ + "static/media/104faces_v2.e1cbbae8.gif";